module.exports = __webpack_public_path__ + "static/media/nav2.5971d67b.svg";